import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export var Button = function (_a) {
    var label = _a.label, icon = _a.icon, onClick = _a.onClick, className = _a.className;
    return (_jsxs("button", { onClick: onClick, className: "flex items-center justify-center bg-[#6c47ff]  px-4 py-2 rounded-xl text-sm font-medium hover:bg-[#5a3ed6] transition cursor-pointer ".concat(className), children: [_jsx("span", { className: 'mr-2', children: icon }), label] }));
};
